import { render } from "./AddTaskButton.vue?vue&type=template&id=3bb595d9"
import script from "./AddTaskButton.vue?vue&type=script&lang=js"
export * from "./AddTaskButton.vue?vue&type=script&lang=js"

import "./AddTaskButton.vue?vue&type=style&index=0&id=3bb595d9&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__